var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMallLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 8.17676C27.0904 8.17676 29.5904 10.6868 29.5904 13.7668V13.9868H18.4004V13.7668C18.4004 10.6768 20.9104 8.17676 23.9904 8.17676H24.0004Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4004 18.9368C18.4004 22.0268 20.9004 24.5268 23.9904 24.5268C27.0804 24.5268 29.5804 22.0268 29.5804 18.9368",
    stroke: "#121619",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0004 13.9971H15.0004C13.0122 13.9971 11.4004 15.6088 11.4004 17.5971V32.5771C11.4004 34.5653 13.0122 36.1771 15.0004 36.1771H33.0004C34.9886 36.1771 36.6004 34.5653 36.6004 32.5771V17.5971C36.6004 15.6088 34.9886 13.9971 33.0004 13.9971Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMallLight);
export default __webpack_public_path__ + "static/media/icon_mall_light.95fe4158.svg";
export { ForwardRef as ReactComponent };